import React from "react";
import "../styles/about.css";

export default function About() {
  return (
    <div className="about-page">

      {/* ===== HERO ===== */}
      <section className="about-hero">
        <h1>📜 गावाबद्दल</h1>
        <p>बेलपिंपळगाव – परंपरा • संस्कृती • प्रगती</p>
      </section>

      {/* ===== INTRO ===== */}
      <section className="about-section">
        <h2>🏡 गावाची ओळख</h2>
        <p>
          बेलपिंपळगाव हे महाराष्ट्रातील एक शांत, सुंदर व प्रगतशील गाव आहे.
          निसर्गाच्या सान्निध्यात वसलेले हे गाव एकता, संस्कृती आणि परिश्रमासाठी
          ओळखले जाते. गावातील लोक मेहनती, कष्टाळू आणि सामाजिक बांधिलकी
          जपणारे आहेत.
        </p>
      </section>

      {/* ===== HISTORY ===== */}
      <section className="about-section light">
        <h2>📖 गावाचा इतिहास</h2>
        <p>
          बेलपिंपळगावचा इतिहास परंपरा आणि संस्कृतीने समृद्ध आहे.
          पिढ्यानपिढ्या चालत आलेली शेती, समाजसेवा आणि सहकार्याची परंपरा
          आजही गावकऱ्यांच्या जीवनात दिसून येते.
        </p>
      </section>

      {/* ===== LIFESTYLE ===== */}
      <section className="about-section">
        <h2>🌱 सामाजिक ऐक्य</h2>
        <p>
          या गावात सर्वधर्म समभाव, आपुलकी आणि एकोप्याचे वातावरण आहे.
          सण, उत्सव, जयंती व यात्रा हे सर्व गावकरी एकत्र येऊन
          मोठ्या उत्साहात साजरे करतात.
        </p>
      </section>

      {/* ===== ECONOMY ===== */}
      <section className="about-section light">
        <h2>🌾 उपजीविका व अर्थव्यवस्था</h2>
        <p>
          बेलपिंपळगाव हे प्रामुख्याने शेतीप्रधान गाव आहे.
          शेतीसोबत दुग्धव्यवसाय, लघुउद्योग आणि व्यवसायातून
          गावाचा आर्थिक विकास होत आहे.
        </p>
      </section>

      {/* ===== EDUCATION ===== */}
      <section className="about-section">
        <h2>🎓 शिक्षण व प्रगती</h2>
        <p>
          गावात शिक्षणाला विशेष महत्त्व दिले जाते.
          डिजिटल शिक्षण, स्पर्धा परीक्षा आणि कौशल्य विकासामुळे
          युवक-युवती विविध क्षेत्रात यशस्वी होत आहेत.
        </p>
      </section>

      {/* ===== STATS ===== */}
      <section className="about-stats">
        <div className="stat">👥 लोकसंख्या<br /><span>5384 (2011)</span></div>
        <div className="stat">🏠 घरे<br /><span>1200+</span></div>
        <div className="stat">🚰 पाणीपुरवठा<br /><span>24x7</span></div>
        <div className="stat">🧹 स्वच्छता<br /><span>100%</span></div>
      </section>

      {/* ===== FUTURE ===== */}
      <section className="about-section highlight">
        <h2>🚀 भविष्याची दिशा</h2>
        <p>
          परंपरेचा सन्मान राखत आधुनिकतेकडे वाटचाल करणे
          हे बेलपिंपळगावचे ध्येय आहे.
          शिक्षण, स्वच्छता, आरोग्य व डिजिटल सेवा
          यामधून गावाला आदर्श व स्मार्ट गाव बनवण्याचा संकल्प आहे.
        </p>
      </section>

    </div>
  );
}
